export const MP_LEVELS = {
  MEDIA_PLAN: 'media_plan',
  ACTIVITY: 'activity',
  FLIGHT: 'flight',
} as const;

export const MP_LEVELS_ICONS = {
  [MP_LEVELS.MEDIA_PLAN]: 'Table',
  [MP_LEVELS.ACTIVITY]: 'Activity',
  [MP_LEVELS.FLIGHT]: 'Calendar',
} as const;

export const MP_LEVELS_LABELS = {
  [MP_LEVELS.MEDIA_PLAN]: 'Media Plan',
  [MP_LEVELS.ACTIVITY]: 'Activity',
  [MP_LEVELS.FLIGHT]: 'Flight',
} as const;

export const YYYY_MM_DD = 'yyyy-MM-dd';

export const NO_DECIMALS = 0;

export const SYSTEM_CURRENCY = 'urn:mint:field:currency';
